import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { LockOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { color } from "../StyleData/Config";

const NotAuthenticate = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "80vh",
        gap: "1rem",
        textAlign: "center",
        px: 2,
      }}
    >
      <LockOutlined sx={{ fontSize: "4rem", color: color.TableButtonColor }} />
      <Typography
        sx={{
          fontSize: "1.5rem",
          fontWeight: 600,
          color: color.masterPageTitleColor,
        }}
      >
        Access Denied
      </Typography>
      <Typography
        sx={{
          fontSize: color.fontSize,
          color: color.sideLabelColor,
          maxWidth: "26rem",
        }}
      >
        You are not authenticated to view this page. Please sign in with an
        account that has access.
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate("/")}
        sx={{
          textTransform: "none",
          mt: "0.5rem",
          backgroundColor: color.TableButtonColor,
          "&:hover": { backgroundColor: color.buttonDisable },
        }}
      >
        Go to Login
      </Button>
    </Box>
  );
};

export default NotAuthenticate;
